module.exports = ".success-dialog-icon{color:#52d877;font-size:100px;border-radius:50%;border:2px solid #52d877;padding:.75rem}"